import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for list usercontrol
export const ListUsageControl = createSlice({
  name: "ListUsageControl",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_ListUsageControl: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_ListUsageControl: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_ListUsageControl: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    ListUsageControl_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearDataListUsageControl: (state) => {
      state.data = [];
    },
  },
});
export default ListUsageControl.reducer;
export const {
  list_ListUsageControl,
  success_api_call_ListUsageControl,
  failure_api_call_ListUsageControl,
  ListUsageControl_is_first,
  clearDataListUsageControl,
} = ListUsageControl.actions;
